export default function getNextMap(options) {
  if (options && options.length > 0) {
    return JSON.parse(options).reduce((res, item) => {
      if(item instanceof Object && item.goto) {
        res[item.val] = item.goto
      }
      return res
    }, {})
  }
  else {
    return {}
  }
}